import { createContext } from 'utils/react-helpers';

const [RiskManagerProvider, useRiskManager] = createContext({
  name: 'RiskManagerCardContext',
});

export { RiskManagerProvider, useRiskManager };
